var $ = require('@alife/alpha-jquery/jquery');

var sepicalKey = {
    9: 'tab',
    13: 'enter',
    27: 'esc',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    32: 'space',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    46: 'del'
};

/**
 * @module alpha-mixin/key-binder
 * @mixin
 * @type {{}}
 */
function KeyBinder() {
    this.after('initialize', function () {
        this._initKeyBinders();
    });

    this.before('destroy', function(){
        this._destroyKeyBinders();
    });
}


KeyBinder.prototype.keyBinder = {};

KeyBinder.prototype.keyBinderNode = null;

KeyBinder.prototype._initKeyBinders = function () {
    var keys = this.keyBinder, self = this, lastKey;

    this.keyBinderNode = this.keyBinderNode || this.element || $({});

    if(this.keyBinderSupport === false) {
        return false;
    }

    this.keyBinderNode.on('keydown.keybinder', function (e) {
        var code, match;
        if(sepicalKey[e.keyCode]){
            code = sepicalKey[e.keyCode];
        }else{
            code = String.fromCharCode(e.keyCode).toLowerCase();
        }
        if (this !== e.target && (/textarea|select/i.test(e.target.nodeName) ||
            e.target.type === "text" || e.target.getAttribute('contenteditable') == 'true' )) {
            return;
        }
        if (e.ctrlKey) {
            match = keys['ctrl+' + code];
        } else if (e.shiftKey) {
            match = keys['shift+' + code];
        } else if (e.altKey) {
            match = keys['alt+' + code];
        } else {
            match = keys[code];
        }
        if (!match) {
            if (lastKey) {
                match = keys[lastKey + ' ' + code];
            }
        }
        if (typeof match == 'string') {
            match = self[match].bind(self);
        } else if (typeof match == 'function') {
            match = match.bind(self);
        }
        if (typeof match == 'function') {
            match(e);
        }
        lastKey = code;
    });
};

KeyBinder.prototype._destroyKeyBinders = function(){
    this.keyBinderNode.off('keydown.keybinder');
};

KeyBinder.prototype.addKeyBinder = function(key, handle){
    this.keyBinder[key] = handle;
};

KeyBinder.prototype.removeKeyBinder = function(key){
    delete this.keyBinder[key];
};



module.exports = KeyBinder;
